import LoadingIndicator from 'components/loading_indicator'
import SpecialCandidateDestination from 'entities/user_notice/special_destination_candidate'
import { includes, isEmpty, xor } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './list.module.scss'
import SpecialListItem from './special_list_item'

const SpecialList = ({ specials, isLoading, specialTypes, cancelButton, completeButton, onUpdateSelection }) => {
  const handleItemChecked = type => {
    const newSelections = xor(specialTypes, [type]) // xorを利用して、選択状態なら選択を解除し、未選択なら選択状態にする
    onUpdateSelection(newSelections)
  }

  const specialList = isEmpty(specials)
    ? null
    : specials.map(special => (
        <SpecialListItem
          key={special.type}
          isChecked={includes(specialTypes, special.type)}
          special={special}
          onChange={handleItemChecked}
        />
      ))

  return (
    <div className={styles.container}>
      <div className={styles.body}>{isLoading ? <LoadingIndicator /> : specialList}</div>
      <div className={styles.footer}>
        {cancelButton}
        {completeButton}
      </div>
    </div>
  )
}

SpecialList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  specials: PropTypes.arrayOf(PropTypes.instanceOf(SpecialCandidateDestination)).isRequired,
  specialTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  cancelButton: PropTypes.element.isRequired,
  completeButton: PropTypes.element.isRequired,
  onUpdateSelection: PropTypes.func.isRequired
}

export default SpecialList
